import { AxiosError, AxiosResponse } from "axios";
import { axiosOrderInstance } from "config";
import { useAxiosQuery } from "hooks";
import { UseQueryOptions } from "react-query";

interface EncounterOrderCancellationCountersResponse {
  cancelled: number;
  requestCancellation: number;
  requestCancellationPRNMedications: number;
}

function useEncounterOrderCancellationCounters(
  encounterId: string,
  options: UseQueryOptions<
    AxiosResponse<EncounterOrderCancellationCountersResponse>,
    AxiosError
  >
) {
  return useAxiosQuery(
    ["encounterCancellationOrderCounters", { encounterId }],
    () =>
      axiosOrderInstance.get<EncounterOrderCancellationCountersResponse>(
        `v1/cancellation/counters/by-encounter/${encounterId}`
      ),
    options
  );
}

export { useEncounterOrderCancellationCounters };
export type { EncounterOrderCancellationCountersResponse };
